import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getOrganizationDashboardAssetTypesSummaryExport } from '@api/dashboardPO';

import { IOrganizationExportFileDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { ESnackbarTypes } from '@enums/common';

import { DASHBOARD_ASSET_TYPES_SUMMARY_ORGANIZATION_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useMutateOrganizationDashboardAssetTypesSummaryExport() {
	const dispatch = useAppDispatch();

	const {
		mutate: exportOrganizationDashboardAssetTypesSummary,
		isLoading: isLoadingOrganizationDashboardAssetTypesSummaryExport,
	} = useMutation<IOrganizationExportFileDTO>({
		mutationKey: [DASHBOARD_ASSET_TYPES_SUMMARY_ORGANIZATION_EXPORT],
		mutationFn: getOrganizationDashboardAssetTypesSummaryExport,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportOrganizationDashboardAssetTypesSummary,
		isLoadingOrganizationDashboardAssetTypesSummaryExport,
	};
}
